import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  textWrapper: {
    color: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 940,
    textAlign: 'center',
  },
  title: {
    fontFamily: 'Brilliant Cut Pro',
    color: theme.palette.common.white,
    fontSize: 54,
    [theme.breakpoints.down('sm')]: {
      fontSize: 32,
    },
  },
  message: {
    fontFamily: 'Brilliant Cut Pro',
    color: theme.palette.common.white,
    fontSize: 44,
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  secondMessage: {
    fontFamily: 'Brilliant Cut Pro',
    color: theme.palette.common.white,
    marginTop: theme.spacing(4),
    maxWidth: 600,
    fontSize: 24,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
}));

const LoginError = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.textWrapper}>
        <Typography className={classes.title}>
          ACCESS DENIED
        </Typography>
        <Typography className={classes.message}>
          Website reserved for the CWI Awards week participants.
        </Typography>
        {/* <Typography className={classes.secondMessage}>
        If you are assisting someone, please use the Delegate Access button.
        </Typography> */}
      </div>
    </div>
  );
};

export default LoginError;
